module.exports = __webpack_public_path__ + "assets/img/mask-bg2-long.6e3e7123.png";